module.exports = __webpack_public_path__ + "static/img/main-location-icon.8cb90d3d.svg";